// extracted by mini-css-extract-plugin
module.exports = {"companies":"styles_companies__2b-BE"};